import { FC, ReactElement, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { formatAmount } from '@/common/utils/formatNumber';
import { SliderMui } from '@/shared/SliderMui';

interface Props {
  handler: (value: number) => void;
  minValue: number;
  maxValue: number;
  step: number;
  initialValue?: number;
  label?: ReactElement | string;
  hasDisplay?: boolean;
}

export const SliderWidget: FC<Props> = ({
  handler,
  minValue,
  maxValue,
  step,
  initialValue,
  label,
  hasDisplay = true,
}) => {
  const [currentValue, setCurrentValue] = useState<number>(
    initialValue || minValue
  );

  useEffect(() => {
    if (initialValue) {
      setCurrentValue(initialValue);
    }
  }, [initialValue]);

  const handleValue = (value: number) => {
    setCurrentValue(value);
    handler(value);
  };

  return (
    <div>
      <div className={styles.displayWrapper}>
        {hasDisplay && (
          <div className={styles.valueDisplay}>
            <span>{formatAmount(currentValue)}</span>
            {label && <span>{label}</span>}
          </div>
        )}
        <div className={hasDisplay ? styles.sliderAbsolute : ''}>
          <SliderMui
            value={currentValue}
            min={minValue}
            max={maxValue}
            step={step}
            handler={handleValue}
          />
        </div>
      </div>
      <div className={styles.scaleWrapper}>
        <div className="font-bold">
          {formatAmount(minValue)}
          {!!label && ' '}
          {label ?? ''}
        </div>
        <div className="font-bold">
          {formatAmount(maxValue)}
          {!!label && ' '}
          {label ?? ''}
        </div>
      </div>
    </div>
  );
};
